var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import dayjs from 'dayjs';
import React from 'react';
import { prevent } from '../../../common/utils';
import { styles } from '../components/input.styles';
import { useInput, listen, useInputState } from '../components/input.hook';
import { cleanProps, getDate, isSame } from './text-date-input.helpers';
import { useDate, useKeys } from './hooks';
import classNames from 'classnames';
export function useDateInput(autocompletProps, ref) {
    var props = cleanProps(autocompletProps);
    var _a = useInputState(props, ref.current.day), value = _a.value, setValue = _a.setValue, inputProps = _a.inputProps, error = _a.error, initialState = _a.initialState;
    var state = __assign(__assign({}, initialState), { getDate: function () { return value; }, isValid: function () { var _a; return !value || ((_a = dayjs(value || null)) === null || _a === void 0 ? void 0 : _a.isValid()); }, isEmpty: function () { return !value; }, setFocus: function (input) {
            var _a, _b, _c, _d, _e, _f;
            if (input == 'd')
                (_a = ref.current.day.current) === null || _a === void 0 ? void 0 : _a.focus();
            else if (input == 'm')
                (_b = ref.current.month.current) === null || _b === void 0 ? void 0 : _b.focus();
            else if (input == 'y')
                (_c = ref.current.year.current) === null || _c === void 0 ? void 0 : _c.focus();
            else if (input == 'h')
                (_d = ref.current.hour.current) === null || _d === void 0 ? void 0 : _d.focus();
            else if (input == 'i')
                (_e = ref.current.minute.current) === null || _e === void 0 ? void 0 : _e.focus();
            else
                (_f = ref.current.day.current) === null || _f === void 0 ? void 0 : _f.focus();
        }, emitChange: function (value, event) {
            if (!value) {
                value = null;
                if (event.target)
                    event.target['value'] = null;
            }
            setValue(value);
            props.onChangeValue && props.onChangeValue(value);
            props.onChange && props.onChange(event);
        } });
    var dates = useDate(state, autocompletProps);
    var keys = useKeys(state, autocompletProps);
    var input = useInput(state, props);
    React.useEffect(function () {
        if (isSame(value, props.value)) {
            var date = getDate(props.value);
            setValue(date);
            dates.set(date);
        }
    }, [props.value]);
    return {
        container: __assign(__assign({}, input.container), { onClear: listen(input.container.onClear, dates.onClear), error: props.error || error, errored: dates.error || !state.isValid() }),
        dayInput: __assign(__assign(__assign({}, inputProps), input.input), { autoFocus: inputProps.autoFocus, className: classNames(styles.styles.inputFocused, styles.styles.inputRight, dates.isErrored('d') && styles.styles.inputErrored), type: 'number', maxLength: 2, value: dates.day, onChange: listen(dates.onChangeDay), onKeyUp: listen(keys.onKeyUpDay, input.input.onKeyUp, inputProps.onKeyUp) }),
        monthInput: __assign(__assign(__assign({}, inputProps), input.input), { autoFocus: false, className: classNames(styles.styles.inputFocused, styles.styles.inputCenter, dates.isErrored('m') && styles.styles.inputErrored), type: 'number', maxLength: 2, value: dates.month, onChange: listen(dates.onChangeMonth), onClick: listen(prevent), onKeyUp: listen(keys.onKeyUpMonth, input.input.onKeyUp, inputProps.onKeyUp) }),
        yearInput: __assign(__assign(__assign({}, inputProps), input.input), { autoFocus: false, className: classNames(styles.styles.inputFocused, dates.isErrored('y') && styles.styles.inputErrored), type: 'number', maxLength: 4, value: dates.year, onChange: listen(dates.onChangeYear), onClick: listen(prevent), onKeyUp: listen(keys.onKeyUpYear, input.input.onKeyUp, inputProps.onKeyUp) }),
        hourInput: __assign(__assign(__assign({}, inputProps), input.input), { autoFocus: false, className: classNames(styles.styles.inputFocused, styles.styles.inputRight, dates.isErrored('h') && styles.styles.inputErrored), type: 'number', maxLength: 2, value: dates.hour, onChange: listen(dates.onChangeHour), onClick: listen(prevent), onKeyUp: listen(keys.onKeyUpHour, input.input.onKeyUp, inputProps.onKeyUp) }),
        minuteInput: __assign(__assign(__assign({}, inputProps), input.input), { autoFocus: false, className: classNames(styles.styles.inputFocused, dates.isErrored('i') && styles.styles.inputErrored), type: 'number', maxLength: 2, value: dates.minute, onChange: listen(dates.onChangeMinute), onClick: listen(prevent), onKeyUp: listen(keys.onKeyUpMinute, input.input.onKeyUp, inputProps.onKeyUp) })
    };
}
